import { render, staticRenderFns } from "./barChartFour.vue?vue&type=template&id=1df9e1fd"
import script from "./barChartFour.vue?vue&type=script&lang=js"
export * from "./barChartFour.vue?vue&type=script&lang=js"
import style0 from "./barChartFour.vue?vue&type=style&index=0&id=1df9e1fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports